import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'antd';
import { CalendarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import 'moment/locale/fr';
import ReactDOM from 'react-dom';
import DdnHeField from '../components/DdnHeField';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const {data} = props

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined/>,
                }
            }

            var prefix = "[ANNIV]_"

            const listFieldProps = listField ? listField : null
            const finalName = prefix + data.fieldKey

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={`${data.label || t`Date de naissance`} :`}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={[{required: data.required || false, message: t`Ce champ est obligatoire`}]}
                        tooltip={tooltip}
                    >
                        <DdnHeField/>
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-contact-ddn' + namespace,
        title: t`Date de naissance`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CalendarOutlined/>,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    }
                }
            },
        },
    }
}
